var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-login p-b-70 propay" }, [
    _vm.loading
      ? _c("div")
      : _c("div", [
          _c(
            "div",
            { staticClass: "main", style: "background:" + _vm.colorList[0] },
            [
              _c("img", { attrs: { src: _vm.baseUrl + _vm.imagesList[0] } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cbtn",
                  style: "background:" + _vm.colorList[2],
                  on: {
                    click: function($event) {
                      return _vm.submitForm(0)
                    }
                  }
                },
                [_c("div", { staticClass: "text" }, [_vm._v("立即点击报名")])]
              ),
              _vm._v(" "),
              _vm._l(_vm.imagesList, function(item, index) {
                return index > 0
                  ? _c("img", {
                      key: index,
                      attrs: { src: _vm.baseUrl + item }
                    })
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "price" }, [
              _vm._v(_vm._s(_vm.produInfo.productPrice))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text",
                on: {
                  click: function($event) {
                    return _vm.submitForm(1)
                  }
                }
              },
              [_c("div", { staticClass: "breathe" }, [_vm._v("立即报名")])]
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45a732f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a732f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/custIndex.vue
// module id = ouyX
// module chunks = 1